import {DriverContactFormServiceTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function driverContactFormServiceTypeNameFilter(type: DriverContactFormServiceTypeEnum) {
  switch(type) {
    case DriverContactFormServiceTypeEnum.Taxi: return i18n.t(LF.Taxi) as string;
    case DriverContactFormServiceTypeEnum.Courier: return i18n.t(LF.Courier) as string;
    case DriverContactFormServiceTypeEnum.BikeService: return i18n.t(LF.BikeService) as string;
    case DriverContactFormServiceTypeEnum.Unknown: return i18n.t(LF.Undefined) as string;
  }
}
